// Module
var code = `<!-- The colour of a label is data, so the template sets the border colour and
     the text colour inline. The rest of the chip is in the LESS file. -->
<div class="media-labels">
  <span class="jumbotron-chip media-labels-chip"
    ng-repeat="item in \$ctrl.MediaLabels | orderBy:'name' track by item.id"
    ng-style="{'border-color': item.color, 'color': item.color}">
    {{item.name}}
    <button type="button" class="media-labels-action" ng-click="\$ctrl.removeLabel(item.id)"
      aria-label="Remove label {{item.name}}" title="Remove label">
      <i class="fas fa-times" aria-hidden="true"></i>
    </button>
  </span>
</div>
`;
// Exports
export default code;